import React from 'react';
import { Shield, X } from 'lucide-react';

export default function InsyncGuardInfo({ className = '', suffix = '' }) {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className={`inline-flex items-center gap-1 cursor-pointer hover:text-orange-600 transition-colors ${className}`}
                aria-label="Learn about InsyncGuard"
            >
                <Shield className="h-3.5 w-3.5 text-orange-500" />
                <span>Protected by InsyncGuard{suffix}</span>
            </button>

            {open && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 p-4"
                    role="dialog"
                    aria-modal="true"
                    aria-label="About InsyncGuard"
                    onClick={() => setOpen(false)}
                >
                    <div
                        className="w-full max-w-lg rounded-xl bg-white shadow-2xl border border-gray-200"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
                            <div className="inline-flex items-center gap-2">
                                <Shield className="h-5 w-5 text-orange-500" />
                                <h3 className="text-lg font-semibold text-gray-900">What is InsyncGuard?</h3>
                            </div>
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                                aria-label="Close"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>

                        <div className="px-5 py-4 text-sm text-gray-700 space-y-3">
                            <p>
                                InsyncGuard is Insync Insurance&apos;s security assurance layer for this platform.
                            </p>
                            <ul className="list-disc pl-5 space-y-1">
                                <li>Enforces identity and access controls through Microsoft Entra ID.</li>
                                <li>Protects operational data with policy-based guardrails and monitoring.</li>
                                <li>Supports auditability and secure use of communication workflows.</li>
                            </ul>
                            <p className="text-gray-500">
                                If you need access changes or have a security concern, contact Insync Digital.
                            </p>
                        </div>

                        <div className="border-t border-gray-200 px-5 py-3 flex justify-end">
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="px-4 py-2 rounded-md bg-orange-600 text-white text-sm font-medium hover:bg-orange-700 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
